export class ReportParameter {
  LayoutDefinitionDescription: string;
  LayoutDefinitionId: number;
  FieldName: string;
  Label: string;
  DataType: ReportParameterDataType;
  SQLStatementId: number;
  DefaultValue: string;
  CssClasses: string;
  TagProperties: string;
  HowToUseIt: string;
  SortOrder: number;
  Required: boolean;
  FieldDescription: string;
  TempData: string;
  Id: number;
  Options?: any[];
  Hidden: boolean = false;
}

export enum ReportParameterDataType {
  Field = 1,
  Date = 2,
  Time = 3,
  DropDown = 4,
  MultiSelect = 5,
  BusinessPartnerProperties = 6,
  ItemProperties = 7,
  Number = 8
}
